// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__S3zzX","col":"styles_col__3hHs0"};